import { render, staticRenderFns } from "./LoopIcon.vue?vue&type=template&id=9381c4d6&"
import script from "./LoopIcon.vue?vue&type=script&lang=js&"
export * from "./LoopIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports